// extracted by mini-css-extract-plugin
export var roundButtonBase = "styles-module__roundButtonBase___VdH6e";
export var largeButton = "styles-module__largeButton___IFn4r";
export var smallButton = "styles-module__smallButton___fYYUI";
export var proBadge = "styles-module__proBadge___gF04H";
export var button = "styles-module__button___BWd9b";